// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type GetTaskParams = {
  include?: string | null;
  module_id?: string | null;
  course_id?: string | null;
};
